export const routes = {
  index: "/",
  admin: "/admin",
  selectClient: "/clients",
  selectTopic: "/topics",
  overview: "/overview",
  report: "/report",
};
